<template>
  <div class="detail-box">
    <div class="detail-info">
      <div class="name">苏州市广济医院</div>
      <div class="price">￥{{ cost }}</div>
      <div class="detail-status">交易成功</div>
    </div>
    <div class="detail-cell">
      <van-cell-group inset>
        <van-cell title="付款方式">
          <template #default>
            {{ paymentMethod || '-' }}
          </template>
        </van-cell>
        <van-cell title="商品说明">
          <template #default>
            {{ productDescription || '-' }}
          </template>
        </van-cell>
        <van-cell title="创建时间">
          <template #default>
            {{ operDate || '-' }}
          </template>
        </van-cell>
        <van-cell title="订单号">
          <template #default>
            {{ orderNumber || '-' }}
          </template>
        </van-cell>
        <!-- <van-cell title="商家订单号">
          <template #default>
            {{ paymentMethod }}
          </template>
        </van-cell> -->
      </van-cell-group>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      cost: '',
      deptName: '',
      operDate: '',
      orderNumber: '',
      paymentMethod: '',
      productDescription: ''
    }
  },
  created() {
    const { cost, deptName, operDate, orderNumber, paymentMethod, productDescription } = this.$route.query
    this.cost = cost
    this.deptName = deptName
    this.operDate = operDate
    this.orderNumber = orderNumber
    this.paymentMethod = paymentMethod
    this.productDescription = productDescription
  },
  mounted() {
  },
  methods: {}
}
</script>
<style lang="less" scoped>
.detail-box{
  min-height: calc(100vh - .4rem);
  .detail-info{
    padding: .2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: .15rem;
    background-color: #fff;
    margin-bottom: .1rem;
    border-radius: .1rem;
    .name{
      font-size: .2rem;
    }
    .price{
      font-size: .3rem;
      margin: .15rem 0 .1rem;
      color: #2B8CFF;
    }
    .detail-status{
      font-size: .18rem;
    }
  }
  .detail-cell{
    /deep/.van-cell-group{
      padding: .1rem 0;
      .van-cell__title{
        max-width: 1rem;
      }
    }
  }
}
</style>
